import { render, staticRenderFns } from "./goods-sku.vue?vue&type=template&id=0c18b612&scoped=true&"
import script from "./goods-sku.vue?vue&type=script&lang=js&"
export * from "./goods-sku.vue?vue&type=script&lang=js&"
import style0 from "./goods-sku.vue?vue&type=style&index=0&id=0c18b612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c18b612",
  null
  
)

export default component.exports